export function CompanyInfo() {
  return (
    <section className="bg-gray-800 text-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Our Portfolio - Column 01 */}
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <span className="text-4xl font-light text-gray-400">01</span>
              <div>
                <h2 className="text-2xl font-semibold mb-4">Our Portfolio</h2>
              </div>
            </div>
            <div className="ml-12">
              <p className="text-gray-300 leading-relaxed">
                Aircraft Specialists (ASI) is a full-service aviation partner offering comprehensive 
                FBO services, aircraft maintenance, propeller and governor overhauls, {' '}
                <a 
                  href="https://pfajets.com/aircraft-management/" 
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  aircraft management
                </a>
                , and {' '}
                <a 
                  href="https://pfajets.com/charter/" 
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  aircraft charter services
                </a>
                . ASI began in 1976 as a propeller overhaul company and has emerged as a leader in the provision of business and general aviation support services.
              </p>
            </div>
          </div>

          {/* Our Approach - Column 02 */}
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <span className="text-4xl font-light text-gray-400">02</span>
              <div>
                <h2 className="text-2xl font-semibold mb-4">Our Approach</h2>
              </div>
            </div>
            <div className="ml-12">
              <p className="text-gray-300 leading-relaxed">
                We scrupulously employ staff who are committed to a culture of excellence and 
                uncompromising safety and are passionate about aviation. Those principles 
                resonate in everything we do. Our highest mission is to provide every customer 
                with an unrivaled and elevated experience with every touch point.
              </p>
            </div>
          </div>

          {/* Our Location - Column 03 */}
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <span className="text-4xl font-light text-gray-400">03</span>
              <div>
                <h2 className="text-2xl font-semibold mb-4">Our Location</h2>
              </div>
            </div>
            <div className="ml-12">
              <p className="text-gray-300 leading-relaxed">
                <a 
                  href="https://www.google.com/maps/place/Aircraft+Specialists+Inc+(ASI)+-+FBO,+Part+145,+Prop,+and+Avionics/@38.3624149,-85.7416629,15z/data=!4m2!3m1!1s0x0:0x97ded0601e9f476b?sa=X&ved=2ahUKEwiPytv9j9X_AhW2jIkEHZPYDpUQ_BJ6BAhaEAk"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  ASI
                </a>
                {' '}is conveniently located only 10 minutes north of Louisville, Kentucky and 
                within 15 minutes of several business parks in Indiana and Kentucky. Located at 
                Clark Regional Airport (KJVY) in Jeffersonville, IN, we are the preferred alternative 
                to SDF, KLOU, and KIMS.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}